import { useEffect, useState } from "react";

const TARGET = new Date("2027-05-12T09:00:00-04:00").getTime();

function calc() {
  const diff = Math.max(0, TARGET - Date.now());
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff / 3600000) % 24);
  const m = Math.floor((diff / 60000) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s };
}

export default function AnniversaryCountdown({ compact = false }) {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const items = [
    { v: t.d, l: "Days" },
    { v: t.h, l: "Hours" },
    { v: t.m, l: "Minutes" },
    { v: t.s, l: "Seconds" },
  ];

  return (
    <div
      className={`grid grid-cols-4 ${compact ? "gap-2" : "gap-3 md:gap-5"} max-w-2xl`}
      data-testid="anniversary-countdown"
    >
      {items.map((it) => (
        <div
          key={it.l}
          className="card-dark text-center px-2 py-4 md:py-6"
          data-testid={`countdown-${it.l.toLowerCase()}`}
        >
          <div className="font-accent text-3xl md:text-5xl text-amber-500 leading-none">
            {String(it.v).padStart(2, "0")}
          </div>
          <div className="mt-2 text-[10px] md:text-xs tracking-[0.28em] uppercase text-slate-400">
            {it.l}
          </div>
        </div>
      ))}
    </div>
  );
}
